module.exports = __webpack_public_path__ + "static/media/18.880b33a0.svg";